// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/catalog/promo-2/view-1/promo-2-1.scss
// module id = 328
// module chunks = 0